<template>
  <div class="notice-group">
    <p class="notice-head">Access Notice</p>
    <p class="notice-message">You're currently using the Nova B2B dashboard.</p>
    <p class="notice-message">
      Click here to access it:
      <a :href="novaDashboardUrl" rel="noopener noreferrer">{{ novaDashboardUrl }}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'AccessNoticePage',
  computed: {
    novaDashboardUrl() {
      return process.env.VUE_APP_NOVA_DASHBOARD_URL || '#';
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-group {
  margin: auto;
  text-align: center;
  margin-top: 250px;
  margin-bottom: 300px;

  .notice-head {
    font-size: 40px;
    font-weight: bold;
    margin: 0 20px 20px;
  }

  .notice-message {
    max-width: 450px;
    font-size: 18px;
    line-height: 26px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
  }

  a {
    font-size: 18px;
    color: #007eff;
    text-decoration: none;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>

